// src/theme.js
import { createTheme } from "@mui/material/styles";

const PRIMARY_COLOR = "#1976d2"; // blu (fisso)
const SECONDARY_COLOR = "#43a047"; // verde
const ERROR_COLOR = "#d32f2f"; // rosso

export const getTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: PRIMARY_COLOR,
      },
      secondary: {
        main: SECONDARY_COLOR,
      },
      error: {
        main: ERROR_COLOR,
      },
      background: {
        default: mode === "light" ? "#f5f5f5" : "#1B1B1B",
        paper: mode === "light" ? "#ffffff" : "#2c2c2c", // sfondo componenti tipo Card
      },
      text: {
        primary: mode === "light" ? "#000000" : "#ffffff",
        secondary: mode === "light" ? "#555555" : "#cccccc",
      },
    },
  });
